module.exports = __webpack_public_path__ + "static/media/logo-mapbiomas-fogo.7c26b36a.png";